var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" 提现金额选项配置 ")]),_c('el-input',{attrs:{"type":"textarea","rows":11,"placeholder":"请输入内容"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.okClick}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }